import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { Layout, LogoContainer, NowAndNextLayout } from './ListEntry';
import { ListContent } from './TvGuideList';
import { Colors } from '../../../../../play-core/styles/Colors';
import { times } from '../../../../../play-core/utils/times';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ListPlaceholder = ({
  isLoading,
  placeholderChannelCount
}) => /*#__PURE__*/_jsx(Fragment, {
  children: isLoading && /*#__PURE__*/_jsx(ListContent, {
    children: times(placeholderChannelCount, index => /*#__PURE__*/_jsxs(Layout, {
      children: [/*#__PURE__*/_jsx(LogoContainer, {
        to: '',
        children: /*#__PURE__*/_jsx(LogoPlaceholder, {})
      }), /*#__PURE__*/_jsx(NowAndNextLayout, {})]
    }, index))
  })
});
const LogoPlaceholder = styled.div.withConfig({
  displayName: "ListPlaceholder__LogoPlaceholder",
  componentId: "sc-14v7gz8-0"
})(["width:60px;height:26px;background-color:", ";"], Colors.GREY_3a3a3a);